import React, { useCallback, useState } from 'react';
import { BLUR_CONTENT_STYLE_NAME } from 'theme';
import classNames from 'classnames';
import { useAnalytics } from 'util/analytics';
import {
  IGridColumn,
  IGridSorting,
  SortingTypeEnum,
  HeaderClickEvent,
  SortingType,
  IGridProps,
} from './types';
import GridBody from './GridBody';
import GridHeader from './GridHeader';

import styles from './styles.module.scss';

const Grid = ({
  columns,
  data,
  total,
  onSortingChange,
  noValueSymbol,
  className,
  noAd,
  defaultSorting,
  isLoading,
}: IGridProps) => {
  const a = useAnalytics();

  const [sorting, setSorting] = useState<IGridSorting | undefined>(defaultSorting);

  const headerClickHandler = useCallback((event: HeaderClickEvent, column: IGridColumn) => {
    if (column.header.onClick) {
      column.header.onClick(event, column);
    }
  }, [columns]);

  const sortingChangeHandler = (event: HeaderClickEvent, column: IGridColumn) => {
    const { isSortable, columnName } = column.header;

    if (isSortable && columnName) {
      const isSortedColumn = column.dataKey === sorting?.orderBy;
      let direction: SortingType = SortingTypeEnum.DESC;
      let orderBy: string | undefined = column.dataKey;
      // let orderBy: string | undefined = column.orderByKey || column.dataKey;

      if (isSortedColumn && sorting?.direction === SortingTypeEnum.DESC) {
        direction = SortingTypeEnum.ASC;
      }

      if (isSortedColumn && sorting?.direction === SortingTypeEnum.ASC) {
        direction = undefined;
        orderBy = undefined;
      }

      setSorting({ orderBy, direction });
      if (onSortingChange) {
        onSortingChange(event, column, { orderBy, direction });
      }
      a.sort(`${orderBy ?? 'default'} ${direction ?? 'default'}`);
    }
  };

  return (
    <table className={classNames(styles.table, className, { [BLUR_CONTENT_STYLE_NAME]: isLoading })}>
      <GridHeader
        columns={columns}
        onColumnHeaderClick={headerClickHandler}
        onSortingChange={sortingChangeHandler}
        sorting={sorting}
      />
      <GridBody
        data={data}
        columns={columns}
        total={total}
        noValueSymbol={noValueSymbol}
        noAd={noAd}
      />
    </table>
  );
};

export default Grid;
